<template>
    <div>

<!--        <ElderHeader/>-->
        <div class="outer-container mx-auto">
            <v-row class="empty">
<!--                <v-col cols="3" class="back-box">-->
<!--                    <img src="../../../../assets/svg/backIcon.svg" alt="">-->
<!--                </v-col>-->

            </v-row>
            <v-divider></v-divider>
                <v-row cols="12" sm="6" md="3" class="mt-2">
<!--                    <v-divider></v-divider>-->
                    <v-col sm="3">
                        <ApplicantRecordMenu/>
                    </v-col>
                    <v-col sm="6">
                        <div class="error-msg">{{serverResponse}}</div>
                        <Loader :loading="loading" :message="message"/>

                        <router-view></router-view>



                    </v-col>



                    <v-col sm="3">
                        <ApplicantMenu/>

                    </v-col>
                </v-row>
                <v-row cols="12" sm="6" md="3" class="view-bck">
                </v-row>
        </div>
    </div>
</template>

<script>
    // import ElderHeader from "./ElderHeader";
    import ApplicantRecordMenu from "./ApplicantRecordMenu";
    import ApplicantMenu from "./ApplicantMenu";
    import {mapGetters} from "vuex";
    import Loader from "./ElderDashboardBody/Loader";
    export default {
        name: "ElderView",
        components: {Loader, ApplicantMenu, ApplicantRecordMenu,},
        data(){
            return{
                message:'Loading...',
                // loading:false
            }

        },

        created() {


            this.$store.dispatch('fetchApplicantByEmail',this.applicantEmail)

        },


        computed: mapGetters([
            'applicant',
            'applicantEmail',
            'loading',
            'serverResponse'
        ])
    }
</script>

<style scoped>
    .view-bck{

        background: #F6F6F6;
        }
    .outer-container {
        background: #FFF !important;
        border-radius: 10px;
        width: 95% !important;
        box-shadow: 0 15px 30px rgba(130, 130, 130, 0.15);
        padding: 0 !important;
      height: calc(100vh - 120px);
    }
    .empty {
        width: 100% !important;
        margin: 0 auto;
        max-height: 40px !important;
        height: 40px !important;
    }
    .back-box {
        padding-right: 0 !important;
        max-width: 20% !important;
        flex: 0 0 20% !important;
    }
    .error-msg{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 30px;
        color: red;
    }


</style>